<template>
    <main class="m-t-70">

        <div class="page-headline m-b-30 m-t-70 align-center">
            <h1 class="headline page-headline__title m-b-20">{{ pageInfo.title }}</h1>
            <h4 class="tagline page-headline__tagline" v-html="pageInfo.content"></h4>
        </div>

        <div class="container">
            <div class="row top-md">
                <article class="col-lg-6 col-md-6 col-sm-12 col-xs-12" v-for="blog in news" :key="blog.id">
                    <div class="article has-shadow">

                        <router-link :to="{ path: 'blog/' + blog.slug , params: { lang: $parent.$parent.$i18n.locale }}" v-if="blog.source_url == ''">
                            <div class="article__image" v-bind:style="{ backgroundImage: 'url(' + blog.feature_image_url + ')' }"></div>
                        </router-link>

                        <a target="_blank" rel="noopener" :href="blog.source_url" v-else>
                            <div class="article__image" v-bind:style="{ backgroundImage: 'url(' + blog.feature_image_url + ')' }"></div>
                        </a>

                        <div class="article__content">

                          <span class="article__content__source" v-if="blog.author">
                            {{ blog.author.name }}
                          </span>

                          <span class="article__content__source" v-else>
                            <img class="responsive-image" v-if="blog.source_image_url != ''" :src="blog.source_image_url" :alt="blog.source_name" width="100px" />
                          </span>

                          <span class="article__content__date m-t-10">{{ blog.date }}</span>

                        <h1 class="article__content__headline m-t-20 m-b-10">
                            <router-link :to="{ path: 'blog/' + blog.slug , params: { lang: $parent.$parent.$i18n.locale }}" v-if="blog.source_url == ''">
                                {{ blog.title }}
                            </router-link>
                            <a target="_blank" rel="noopener" :href="blog.source_url" v-else>
                                {{ blog.title }}
                            </a>
                        </h1>

                        <p class="article__content__summary" v-html="blog.summary"></p>

                        <router-link :to="{ path: 'blog/' + blog.slug , params: { lang: $parent.$parent.$i18n.locale }}" v-if="blog.source_url == ''" class="button button--link button--link--peach m-t-20">
                            <span class="button--link__text button--link--peach__text">{{ $t("global.readAboutThis") }}</span>
                        </router-link>

                        <a target="_blank" rel="noopener" v-if="blog.source_url != ''" class="button button--link button--link--peach m-t-20" :href="blog.source_url">
                            <span class="button--link__text button--link--peach__text">{{ $t("global.readAboutThis") }}</span>
                        </a>

                    </div>
                    </div>
                </article>
            </div>
        </div>
    </main>
</template>

<script>
export default {
	name: "Blog",
	data() {
		return {
			pageTitle: "Loading...",
			pageInfo: {},
			news: []
		};
	},
	metaInfo() {
		return {
			title: this.pageTitle,
			meta: [
				{ itemprop: "name", content: this.pageInfo.meta_og_description },
				{ itemprop: "description", content: this.pageInfo.meta_og_description },
				{ name: "og:title", content: this.pageInfo.meta_og_title },
				{ name: "og:description", content: this.pageInfo.meta_og_description },
				{ name: "og:url", content: this.pageInfo.meta_url },
				{ name: "og:site_name", content: this.pageInfo.meta_twitter_site },
				{ name: "og:type", content: this.pageInfo.meta_og_type },
				{ name: "og:image", content: this.pageInfo.meta_og_image_url },

				{ name: "twitter:card", content: this.pageInfo.meta_twitter_card },
				{ name: "twitter:site", content: this.pageInfo.meta_twitter_site },
				{ name: "twitter:title", content: this.pageInfo.meta_twitter_title },
				{
					name: "twitter:description",
					content: this.pageInfo.meta_twitter_description
				},
				{
					name: "twitter:creator",
					content: this.pageInfo.meta_twitter_creator
				},
				{ name: "twitter:image", content: this.pageInfo.meta_twitter_image_url }
			]
		};
	},
	created() {
		this.getAll();
		this.getPageInfo();
	},
	methods: {
		getPageInfo() {
			this.$http
				.get(this.$parent.$parent.apiURL + "/Pages?id=4")
				.then(function(response) {
					this.pageInfo = response.body;
					this.pageTitle = this.pageInfo.title;
				});
		},
		getAll() {
			this.$http
				.get(this.$parent.$parent.apiURL + "/news")
				.then(function(response) {
					this.news = response.body;
				});
		}
	}
};
</script>



// WEBPACK FOOTER //
// src/components/Blog.vue